<template>
  <div class="items" @click="addActivity(icon)">
    <div class="icon" :style="`background: ${$route.query.act ? generatedBackground : background}`">
      <img :src="require(`@/assets/images/dadbanan/${icon}.svg`)" />
    </div>
    <div class="name">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    title: {
      type: String,
    },
    background: {
      type: String,
    },
  },
  computed: {
    generatedBackground() {
      let c = ''
      switch (this.$route.query.act) {
        case 'video':
          c = 'rgba(80, 165, 241, 0.25098)'
          break
        case 'pdf':
          c = 'rgba(52, 195, 143, 0.25098)'
          break
        case 'file':
          c = 'rgba(85, 110, 230, 0.25)'
          break
        case 'online':
          c = 'rgba(136, 49, 157, 0.25)'
          break
        case 'link':
          c = 'rgba(254, 189, 23, 0.25)'
          break
        case 'train':
          c = 'rgba(227, 128, 30, 0.25)'
          break
        case 'exam':
          c = 'rgba(244, 106, 106, 0.25098)'
          break
        case 'survey':
          c = 'rgba(159, 214, 69, 0.25098)'
          break
      }
      return c
    },
  },
  methods: {
    addActivity(newQuery) {
      this.$router.push({
        query: {
          ...this.$route.query,
          act: newQuery,
        },
      })
      this.$store.commit('headlines/SET_FILE_FORM', true)
      this.$store.commit('headlines/SET_HEAD_LINE_FORM', false)
      this.$store.commit('headlines/SET_FILE_CARD', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.icon {
  width: 60px;
  height: 60px;
  display: grid;
  place-items: center;
  border-radius: 100%;
  margin: 10px 20px 10px 0;
}

.name {
  margin-right: 20px;
  font-weight: 400;
  font-size: 18px;
  line-height: 15px;
  color: #4e4e56;
  padding: 30px 0;
}

.items {
  width: 233px;
  height: 80px;
  margin-left: 20px;
  display: flex;
  border-radius: 4px;
  cursor: pointer;
}
</style>
